// 定义主登录和题库服务的令牌缓存键。
// 主登录访问令牌的缓存键。
export const TOKEN_KEY = "accessToken";

// 登录返回的刷新凭证，用于后续换取访问令牌。
export const REFRESH_TOKEN_KEY = "refreshToken";

// 题库服务独立访问令牌的缓存键。
export const QB_TOKEN_KEY = "questionBankAccessToken";
